import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { BaseUI } from '../../base.ui';
import { Country, FiscalCountry, Tax } from '../../../domain/data';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { GetCountriesUseCase, TINNotAvailableReason } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-legal-tax',
    templateUrl: './full-data-form-legal-tax.component.html',
    styleUrls: ['./full-data-form-legal-tax.component.scss']
})
export class FullDataFormLegalTaxComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public TINNotAvailableReason: typeof TINNotAvailableReason = TINNotAvailableReason;

    public prefix: string;
    public adding = false;
    public editing = false;
    public currentFiscalCountry: FiscalCountry;
    public countries: Country[] = [];
    public fiscalCountriesComplete = false;

    @Input()
    tax: Tax;

    @Input()
    isLegalPerson = false;

    @Input()
    isDisabled = false;


    constructor(parentEvents: ParentEvents,
                private dialog: MatDialog,
                private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.fiscalCountriesComplete = this.tax.fiscalCountries.length > 0;
        this.prefix = `tftax-${nextUniqueId++}-`;
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase.bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe(transaction => {
                if (transaction.isSuccess) {
                    this.countries = (transaction.data as Country[]);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onFiscalCountryChange() {
        if (this.tax.isOtherCountryPersonFiscal && this.tax.fiscalCountries.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }

    onResize() {
        this.parentEvents.resize();
    }

    onAdd() {
        this.currentFiscalCountry = new FiscalCountry();
        this.adding = true;
        this.editing = false;
    }

    onSave() {
        if (this.adding) {
            this.tax.addFiscalCountry(this.currentFiscalCountry);
            this.fiscalCountriesComplete = true;
        } else if (this.editing) {
            this.tax.updateFiscalCountry(this.currentFiscalCountry);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentFiscalCountry = undefined;

        this.parentEvents.resize();
    }

    onEdit(fiscalCountry: FiscalCountry) {
        this.currentFiscalCountry = cloneDeep(fiscalCountry);
        this.editing = true;
        this.adding = false;
    }

    onRemove(fiscalCountry: FiscalCountry) {
        this.tax.removeFiscalCountry(fiscalCountry);

        if (this.currentFiscalCountry && this.currentFiscalCountry.name === fiscalCountry.name) {
            this.onCancel();
        }

        if (!this.adding && this.tax.fiscalCountries.length === 0) {
            this.onAdd();
        }

        this.fiscalCountriesComplete = this.tax.fiscalCountries.length > 0;
        this.parentEvents.resize();
    }
}
